import _ from "underscore";

// Initiates request
export function requestAnalysis() {
	return {
		type: "requestAnalysis",
	};
}

// // Filter analysis
// export function filterAnalysis(filter){
//   return {
//     type: 'filterAnalysis',
//     filter
//   };
// }

// receive analysis
// TODO: remove filter once the API filters content
export function receiveAnalysis(json, baseTrendMeta) {
	// console.log(json, baseTrendMeta)
	const baseAnalysis = _.filter(json, (analysis) => {
		return baseTrendMeta.id === analysis.narrative;
	});
	return {
		type: "receiveAnalysis",
		analysis: baseAnalysis,
	};
}
